import { render } from "./PagoParteSocial.vue?vue&type=template&id=1cb74664&scoped=true"
import script from "./PagoParteSocial.vue?vue&type=script&lang=js"
export * from "./PagoParteSocial.vue?vue&type=script&lang=js"

import "./PagoParteSocial.vue?vue&type=style&index=0&id=1cb74664&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb74664"]])

export default __exports__